import type { Brand } from "@/modules/layout/main"
import { Page404 } from "@/pages/404"
import { PageDisney } from "@/pages/disney"
import { PageHome } from "@/pages/home"
import { PageMarvel } from "@/pages/marvel"
import { PageStarWars } from "@/pages/star-wars"
import { PageWDW } from "@/pages/wdw"

export const SiteBrand: Brand = {
	Page404: Page404,
	Routes: [
		{
			Component: PageHome,
			Href: "/",
			ShowInMenu: true,
			Title: "Home",
		},
		{
			Component: PageDisney,
			Href: "/disney",
			ShowInMenu: true,
			Title: "Disney",
		},
		{
			Component: PageWDW,
			Href: "/wdw",
			ShowInMenu: true,
			Title: "WDW",
		},
		{
			Component: PageStarWars,
			Href: "/star-wars",
			ShowInMenu: true,
			Title: "Star Wars",
		},
		{
			Component: PageMarvel,
			Href: "/marvel",
			ShowInMenu: true,
			Title: "Marvel",
		},
	],
	Title: "Flight 1401",
}
